export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteProfileEverDialog.json?hash=5e32aefaea39824fbe62509e617fd650";